import React from 'react';
import PropTypes from 'prop-types';
import { FormattedDate } from 'react-intl';

import { H1, H3 } from '../../../components';
import { TranslatedCopy } from '../../../intl/TranslatedCopy';

import { ORDERTYPE_STRING_MAP } from '../../constants';

const OrderReturnsStatusSummary = ({
  accountName,
  department,
  paymentMethod,
  orderType,
  poNumber,
  orderSubmittedBy,
  orderSubmittedDate,
  orderNumber
}) => (
  <div className='orderReturns__section_status p6-sm pt6-sm pb6-sm'>
    <H1>
      <TranslatedCopy id='orderreturns.returnSummary' />
    </H1>
    <ul className='pt5-sm'>
      <li>
        <H3>
          <TranslatedCopy id='global.account' />
        </H3>
        <p>{accountName}</p>
      </li>
      {department && department !== '' && (
        <li>
          <H3>
            <TranslatedCopy id='global.department' />
          </H3>
          <p>{department}</p>
        </li>
      )}
      <li>
        <H3>
          <TranslatedCopy id='global.paymentMethod' />
        </H3>
        <p>{paymentMethod}</p>
      </li>
      <li>
        <H3>
          <TranslatedCopy id='global.orderType' />
        </H3>
        <p>{ORDERTYPE_STRING_MAP[orderType]}</p>
      </li>
      <li>
        <H3>
          <TranslatedCopy id='global.customerPo' />
        </H3>
        <p>{poNumber}</p>
      </li>
      <li>
        <H3>
          <TranslatedCopy id='orderreturns.orderSubmittedBy' />
        </H3>
        <p>{orderSubmittedBy}</p>
      </li>
      <li>
        <H3>
          <TranslatedCopy id='orderreturns.orderReferenceNumber' />
        </H3>
        <p>{orderNumber}</p>
      </li>
      <li>
        <H3>
          <TranslatedCopy id='orderreturns.returnInitiated' />
        </H3>
        <p>
          <FormattedDate value={orderSubmittedDate} timeZone='utc' />
        </p>
      </li>
    </ul>
  </div>
);

OrderReturnsStatusSummary.propTypes = {
  accountName: PropTypes.string.isRequired,
  department: PropTypes.string.isRequired,
  paymentMethod: PropTypes.string.isRequired,
  orderType: PropTypes.string.isRequired,
  poNumber: PropTypes.string.isRequired,
  orderSubmittedBy: PropTypes.string.isRequired,
  orderSubmittedDate: PropTypes.string.isRequired,
  orderNumber: PropTypes.string.isRequired
};

export default OrderReturnsStatusSummary;
